import * as MaterialUiIcons from "@mui/icons-material";
import * as React from "react";
import { alertErrorForegroundRed } from "Styling/Palette/AlertColours";
import { FunctionComponent } from "react";

const ErrorIcon: FunctionComponent = () => <MaterialUiIcons.Cancel htmlColor={alertErrorForegroundRed} />;

export default ErrorIcon;
